import { render, staticRenderFns } from "./coursePlay.vue?vue&type=template&id=5fecb624&scoped=true&"
import script from "./coursePlay.vue?vue&type=script&lang=js&"
export * from "./coursePlay.vue?vue&type=script&lang=js&"
import style0 from "./coursePlay.vue?vue&type=style&index=0&id=5fecb624&scoped=true&lang=css&"
import style1 from "./coursePlay.vue?vue&type=style&index=1&id=5fecb624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fecb624",
  null
  
)

export default component.exports